import React from 'react';
import '../../../pages/Reports/assets/scss/main.scss';

const WgtReportLayout: React.FC = ({ children }) => {
  return <div id="wgt-report">{children}</div>;
};

export default WgtReportLayout;
